<template>
    <div class="wrapper">
        <div class="page-header page-header-small">
            <parallax class="page-header-image" style="background-image: url('img/staciste.jpg')">
            </parallax>
            <div class="content-center">
                <div class="row">
                    <div class="col-md-10 ml-auto mr-auto">
                        <h4>Komplexní služby v oblasti odpadového hospodářství.</h4>
                        <h1 class="title">NAŠE SLUŽBY</h1>
                    </div>
                </div>
            </div>
        </div>
        
        <div class="section">
            <div class="about-description text-left">
                <div class="doleva">
                    <div class="container">
                        <div class="row">
                            <div class="col-md-8 mr-auto ml-auto">
                                <h4 class="subtitle"></h4>
                                <h5 class="description">Nabízíme odstranění nebezpečných i ostatních odpadů. 
                                </h5>
                                <h5 class="description">Předáním odpadů naší společnosti splníte veškeré zákonné náležitosti (předání oprávněné osobě, elektronická evidence přepravy NO, přeprava ADR). 
                                </h5>
                                <h4 class="description">• Sběr a výkup olejů
                                </h4>
                                <h5 class="description odsad">Odstraníme Vaše odpadní minerální oleje. V souladu se zákonem o odpadech předáváme sebrané oleje k recyklaci. Předáním olejů naší společnosti se <a href="/img/osvedceni_cu.pdf" targer="_blank">vyhnete spotřební dani</a>. 
                                </h5>
                                <h4 class="description">• Sběr odpadních emulzí a zaolejovaných vod
                                </h4>
                                <h4 class="description">• Zajištění analýzy olejů, odpadních emulzí a zaolejovaných vod
                                </h4>
                                <h4 class="description">• Sběr nebezpečných odpadů
                                </h4>
                                <h4 class="description">• Sběr a výkup olověných akumulátorů
                                </h4>
                                <h4 class="description">• Ekologické poradenství
                                </h4>
                                <h4 class="description">• Přepravu v režimu ADR
                                </h4>
                            </div>
                        </div>

                    </div>
                </div>
            </div>

            <div class="separator-line separator-primary"></div>

        </div>
    </div>
</template>
<script>
  import { Card, Button, Badge, InfoSection, FormGroupInput, Checkbox } from '@/components';
  import { Select, Option } from 'element-ui'

  export default {
    name: 'about-us',
    bodyClass: 'about-us',
    components: {
      Card,
      InfoSection,
      Badge,
      [Button.name]: Button,
      [Checkbox.name]: Checkbox,
      [FormGroupInput.name]: FormGroupInput,
      [Select.name]: Select,
      [Option.name]: Option,
    },
    data() {
      return {
        form: {
          name: '',
          email: '',
          phone: ''
        }
      }
    }
  }
</script>
<style>
.section {
    padding: 0 0 !important;
}

.about-us {
    padding: 0 0 !important;
}
.about-description, .about-contact {
    padding: 0 0 !important;
}        
.features-3 {
    padding: 20px 0 !important;
}        
.description {
    color: #888 !important;
    font-weight: 500 !important;
}    

.page-header {
    min-height: 80vh !important;
}  

.doleva {
    text_align: left !important;
}  

.subtitle {
    font-weight: 500;
    padding-top: 0px;
}  


.odsad {
    padding-left: 100px !important;
}  
</style>
